"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePrimarySaleHappenedViaToken = exports.getUpdatePrimarySaleHappenedViaTokenInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const shared_1 = require("../shared");
function getUpdatePrimarySaleHappenedViaTokenInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([['discriminator', (0, serializers_1.u8)()]], { description: 'UpdatePrimarySaleHappenedViaTokenInstructionData' }), (value) => ({ ...value, discriminator: 4 }));
}
exports.getUpdatePrimarySaleHappenedViaTokenInstructionDataSerializer = getUpdatePrimarySaleHappenedViaTokenInstructionDataSerializer;
// Instruction.
function updatePrimarySaleHappenedViaToken(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplTokenMetadata', 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
    // Accounts.
    const resolvedAccounts = {
        metadata: {
            index: 0,
            isWritable: true,
            value: input.metadata ?? null,
        },
        owner: {
            index: 1,
            isWritable: false,
            value: input.owner ?? null,
        },
        token: {
            index: 2,
            isWritable: false,
            value: input.token ?? null,
        },
    };
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getUpdatePrimarySaleHappenedViaTokenInstructionDataSerializer().serialize({});
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.updatePrimarySaleHappenedViaToken = updatePrimarySaleHappenedViaToken;
//# sourceMappingURL=updatePrimarySaleHappenedViaToken.js.map